(function(){
    'use strict';
    
    
    
    jcu_js_v1.fn.initShare = function(){
        if(document.querySelector('.course-banner__share') !== null){
            jcu_js_v1.vars.shareButton = document.querySelector('.course-banner__share');
            jcu_js_v1.vars.actionsContainer = document.querySelector('.course-banner__actions');
            jcu_js_v1.vars.shareButton.addEventListener('click', jcu_js_v1.fn.shareClickHandler);
        }
    }

    jcu_js_v1.fn.shareClickHandler = function(e) {
        e.preventDefault();

        var title = document.querySelector('.course-banner__title').innerHTML;
        var url = window.location.href;

        // Web share API
        if (navigator.share) {
            navigator.share({
                title: title,
                url: url
            }).then(function() {
                console.log('Thanks for sharing!');
            }).catch(console.error);
        }

        // Fallback
        else {
            jcu_js_v1.fn.toggleShareModal();
        }
    }
    

    jcu_js_v1.fn.toggleShareModal = function() {
        // console.log('toggle modal');
        var modal = document.querySelector('.course-banner__share-modal');

        // Close modal
        if (modal.classList.contains('open')) {
            jcu_js_v1.fn.closeModal();
        }

        // Open modal
        else {
            jcu_js_v1.fn.openModal();
        }
    }

    jcu_js_v1.fn.handleBackgroundClick = function(e) {
        var modal = document.querySelector('.course-banner__share-modal');
        var isClickInside = modal.contains(e.target);
        var isClickBtn = jcu_js_v1.vars.shareButton.contains(e.target);

        if (!isClickInside && !isClickBtn) {
            // console.log('background clicked');
            jcu_js_v1.fn.closeModal();
        }
    }

    jcu_js_v1.fn.closeModal = function() {
        
        // Add expanded attr
        jcu_js_v1.vars.shareButton.setAttribute('aria-expanded', 'false');
        
        // Hide modal
        var modal = document.querySelector('.course-banner__share-modal');
        modal.classList.remove('open');

        // Remove event listeners
        jcu_js_v1.vars.actionsContainer.removeEventListener('keydown', jcu_js_v1.fn.trapTabKey);
        document.body.removeEventListener('click', jcu_js_v1.fn.handleBackgroundClick);

        // Focus on share button
		jcu_js_v1.vars.shareButton.focus();
    }

    jcu_js_v1.fn.openModal = function() {
        
        // Add expanded attr
        jcu_js_v1.vars.shareButton.setAttribute('aria-expanded', 'true');

        // Open modal
        var modal = document.querySelector('.course-banner__share-modal');
        modal.classList.add('open');
        
        // Handle background click
        document.body.addEventListener('click', jcu_js_v1.fn.handleBackgroundClick);

        // Listen for and trap the keyboard
        jcu_js_v1.vars.actionsContainer.addEventListener('keydown', jcu_js_v1.fn.trapTabKey);

        // Focus first child
        var facebookLink = document.getElementById('course-share-facebook');
		facebookLink.focus();

    }

    jcu_js_v1.fn.trapTabKey = function(e) {
        var firstTabStop = jcu_js_v1.vars.shareButton;
        var lastTabStop = document.getElementById('course-share-email');

        // Check for TAB key press
        if (e.keyCode === 9) {

            // SHIFT + TAB
            if (e.shiftKey) {
                if (document.activeElement === firstTabStop) {
                    e.preventDefault();
                    lastTabStop.focus();
                }

                // TAB
            } else {
                if (document.activeElement === lastTabStop) {
                    e.preventDefault();
                    firstTabStop.focus();
                }
            }
        }

        // ESCAPE
        if (e.keyCode === 27) {
            jcu_js_v1.fn.closeModal();
        }
    }

    // Check for JCU document referrer
    jcu_js_v1.fn.checkForReferrer = function() {
        var is_valid_referrer = jcu_js_v1.fn.hasValidReferrer();

        // Only perform actions if the referrer is valid
        if(is_valid_referrer) {

            // Check for window history
            // Results show a new tab or window is 1 or 2
            if(history.length > 2) {
                // Init the Previous breadcrumb link
                jcu_js_v1.fn.createPreviousLink();

                // Update mobile back button
                jcu_js_v1.fn.updateBannerBackLink();
            }
            
        }
    };

    // Create a previous link for breadcrumbs
    jcu_js_v1.fn.createPreviousLink = function() {
        // Create the link text
        var link_text = 'Previous page';
        var link_text_node = document.createTextNode(link_text);

        // Create the link element and append the link text
        var link_element = document.createElement('a');
        link_element['href'] = document['referrer'];
        link_element.appendChild(link_text_node);

        // Create the list item element and append the link element
        var item_element = document.createElement('li');
        item_element['classList'].add('course-breadcrumb__link');
        item_element.appendChild(link_element);

        // Add the list item to the start of the breadcrumb lists
        var list_element = document.querySelector('.course-breadcrumb .course-breadcrumb__list');
        list_element.insertBefore(item_element, list_element.firstChild);

        // Set up link element behaviour
        //link_element.addEventListener('click', jcu_js_v1.fn.handleHistoryNavigation);
    };

    // Update the behaviour of the banner's back link
    jcu_js_v1.fn.updateBannerBackLink = function() {
        var back_button = document.querySelector('.course-banner__back-btn');

        // Modify the href to go to the referrer
        back_button['href'] = document['referrer'];

        // Set up element behaviour
        //back_button.addEventListener('click', jcu_js_v1.fn.handleHistoryNavigation);
    };

    // Navigate through the window history
    jcu_js_v1.fn.handleHistoryNavigation = function(event) {
        event.preventDefault();

        // Capture current location
        var current_location = window['location']['href'];

        // Capture link data
        var target_link = event['target'];
        var direction = target_link.getAttribute('data-direction');

        // Navigate history
        switch(direction) {
            case 'previous':
                history.back();

                // Sometimes having query parameters adds an additional history state
                // Perform a check to do a second back click just in case
                /*setTimeout(function(){
                    if(window['location']['href'] === current_location) {
                        console.log('Condition met');
                        history.back();
                    }
                }, 1000);*/
                break;
        }
    };


    //
    // Ready
    //

    jcu_js_v1.fn.initShare();

    // Check for breadcrumbs
    if(document.querySelector('.course-breadcrumb') !== null) {
        jcu_js_v1.fn.checkForReferrer();
    }    
     
}());
